import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormField } from '../../../model/responsible/FormField';
import { RadioGroupOption } from '../../../model/RadioGroupOption';
import { MatRadioChange } from '@angular/material/radio';

@Component({
    selector: 'app-multi-radio-group-field',
    templateUrl: './multi-radio-group-field.component.html',
    styleUrls: ['./multi-radio-group-field.component.scss'],
})
export class MultiRadioGroupFieldComponent implements OnInit {
    @Input() public fieldData!: FormField;
    @Input() public model: string = '';
    @Input() public readonly = false;
    @Output() public modelChange = new EventEmitter<string>();

    public options: RadioGroupOption[] = [];
    public fields: FormField[] = [];
    public label: string = '';
    public currentModel: Record<string, any> = {};

    public ngOnInit() {
        this.initializeOptions();
        this.currentModel = this.model ? JSON.parse(this.model) : {};
    }

    private initializeOptions() {
        try {
            if (this.fieldData?.filetypes) {
                const { options, fields, label } = JSON.parse(
                    this.fieldData.filetypes
                );
                if (options) {
                    this.options = options;
                    this.fields = fields;
                    this.label = label;
                } else {
                    console.warn('No options found in parsed data');
                }
            } else {
                console.warn('No filetypes data available');
            }
        } catch (error) {
            console.error('Error parsing options:', error);
            this.options = []; // Fallback to empty array
        }
    }

    public valueChanged(event: MatRadioChange, question: FormField) {
        this.currentModel[question.id] = event.value;
        this.model = JSON.stringify(this.currentModel);
        this.modelChange.emit(this.model);
    }

    public isChecked(question: FormField, option: RadioGroupOption): boolean {
        return this.currentModel[question.id] === option.value;
    }

    public getQuestionValue(question: FormField): string | undefined {
        return this.currentModel[question.id];
    }
}
